import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionText: {
    fontSize: theme.spacing(1.75),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.25px',
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  widthRadio: {
    width: 'auto',
    height: theme.spacing(3),
  },
}))
